import { useSite } from "../lib/site";

export default function QuoteBand() {
  const { settings } = useSite();
  const quote = settings.quote;
  if (!quote) return null;
  return (
    <section data-testid="quote-band" className="border-t border-line bg-surface">
      <div className="max-w-3xl mx-auto px-4 sm:px-8 py-14 md:py-16 text-center">
        <span className="w-2.5 h-2.5 rounded-full bg-enji inline-block mb-6" aria-hidden="true" />
        <p data-testid="quote-text" className="font-serif italic text-2xl md:text-[1.75rem] leading-snug text-ink">
          &ldquo;{quote}&rdquo;
        </p>
        {settings.quote_source ? (
          <p className="text-faint text-sm mt-4">&mdash; {settings.quote_source}</p>
        ) : null}
      </div>
    </section>
  );
}

